import Vue from 'vue'
import VueI18n from 'vue-i18n'

// Import all language files
import en from './lang/en.json'
import sv from './lang/sv.json'
Vue.use(VueI18n)
const messages = { en, sv }

// Create VueI18n instance
const i18n = new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages,
  silentTranslationWarn: true,
})

export default i18n
